import React, { useMemo } from 'react';
import { Typography } from '@mui/material';
import { isNil, round } from 'lodash';

import styles from './ConsistencyCell.module.scss';

type Props = {
  loading: boolean;
  consistency: number | null | undefined;
};

const ConsistencyCell: React.FC<Props> = ({ consistency, loading }) => {
  const loadingOrError = useMemo(
    () => (!consistency && consistency !== 0) || loading,
    [consistency, loading],
  );

  const roundedConsistency = useMemo(
    () => (isNil(consistency) ? null : round(consistency, 0)),
    [consistency],
  );

  return (
    <div className={styles.wrapper} data-testid="forecast-table-consistency-cell">
      {loadingOrError ? (
        <div data-testid="forecast-table-consistency-empty-content" className={styles.emptyContent}>
          <Typography
            className={styles.percent}
            color="text.light"
            component="p"
            data-testid="forecast-table-consistency-empty"
            variant="caption1"
          >
            --
          </Typography>
        </div>
      ) : (
        <Typography
          className={styles.content}
          component="span"
          data-testid="forecast-table-consistency-content"
        >
          <Typography
            className={styles.consistency}
            color="text.primary"
            component="h3"
            data-testid="forecast-table-consistency"
            variant="subHeadline"
          >
            {roundedConsistency}
          </Typography>
          <Typography
            className={styles.percent}
            color="text.primary"
            component="p"
            data-testid="forecast-table-consistency-percent"
            variant="caption1"
          >
            /100
          </Typography>
        </Typography>
      )}
    </div>
  );
};

export default ConsistencyCell;
